import { ActionIcon } from "../../../action-icon";
import { Tooltip } from "../../../tooltip";
import { ToolboxToolProps } from "./toolbox.types";

/**
 * A base component for individual tools in the ImagePreview toolbox.
 * Renders an ActionIcon with a Tooltip.
 */
export const Tool = ({ icon, label, onClick, variant = "transparent", ...props }: ToolboxToolProps) => (
    <Tooltip label={label} withinPortal={false}>
        <ActionIcon
            variant={variant}
            size="sm"
            color="white"
            onClick={onClick}
            icon={icon}
            data-mantine-stop-propagation="true"
            {...props}
        />
    </Tooltip>
);
